import { WebappPlatformApi } from "@juicetechnologyag/webapp-platform-api";

const { KEYCLOAK_URL, KEYCLOAK_REALM, KEYCLOAK_CLIENT_ID } = window.APP_CONFIG;

const config = {
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
};

const webappPlatformApi = WebappPlatformApi(config, {
  onLoad: "check-sso",
  silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
});

export default webappPlatformApi;
